import { render, staticRenderFns } from "./ManuscriptList.vue?vue&type=template&id=566b3ddd&scoped=true&"
import script from "./ManuscriptList.vue?vue&type=script&lang=ts&"
export * from "./ManuscriptList.vue?vue&type=script&lang=ts&"
import style0 from "./ManuscriptList.vue?vue&type=style&index=0&id=566b3ddd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566b3ddd",
  null
  
)

export default component.exports